import {Heading, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {ServiceInspectionReplacementGroup} from '../../kit/groups/ServiceInspectionReplacementGroup';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function ServiceInspectionReplacementSubSection() {
  return (
    <>
      <VFKit.SubSection data-testid="service-inspection-replacement">
        <VStack spacing={4}>
          <Heading size={4}>{i18n.t('entity.vehicle.labels.serviceInspection')}</Heading>
          <VFKit.Group columns={4} data-testid="service-inspection-replacement-group">
            <ServiceInspectionReplacementGroup />
          </VFKit.Group>
        </VStack>
      </VFKit.SubSection>
    </>
  );
}
